<template>
<div>
  <breadcrumb :items="[{ text: 'Fornecedores', to: '/fornecedores' }, { text: 'Cadastrar fornecedor', active: true }]" />
  <b-form @submit.prevent="save" v-if="!isLoading">
    <b-form-group label="CNPJ da organização *">
      <b-form-input v-model="form.cnpj" v-validate="'required'" name="cnpj" v-mask="['##.###.###/####-##']" />
      <field-error :msg="veeErrors" field="cnpj" />
    </b-form-group>
    <b-form-group label="Redes que englobam esta organização *" v-if="isAdmin">
      <form-entities-select type="organizations" :form="form" field="organizations" />
      <field-error :msg="veeErrors" field="organizations" />
    </b-form-group>
    <form-submit :errors="error" :sending="isSending" label="Continuar" />
  </b-form>
</div>
</template>

<script>
import axios from 'axios'
import FormEntitiesSelect from '@/components/FormEntitiesSelect'
import FormSubmit from '@/components/FormSubmit'
import FieldError from '@/components/FieldError'

export default {

  name: 'SupplierRegisterForm',
  data() {
    return {
      form: {
        organizations: [],
        cnpj: '',
        email: '',
        password: '',
      }
    }
  },
  methods: {
    save() {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.isSending = true
          this.error = false
          axios({
            method: 'POST',
            url: 'suppliers',
            data: this.form
          }).then(resp => {
            var supplier = resp.data
            if (supplier && supplier._id) {
              this.notify("Cadastro realizado com sucesso!")
              this.$router.replace('/editar-fornecedor/' + supplier._id)
            }
            this.isSending = false
          }).catch(this.showError)
        }
      })
    }
  },
  components: {
    FormSubmit,
    FormEntitiesSelect,
    FieldError
  }
};
</script>
